const log = {
  error: console.error,
  warn: console.warn,
  info: () => {},
  trace: () => {},
  debug: () => {},
  time: () => {},
  timeEnd: () => {},
  timingKeys: {},
};

export default log;
